import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { NavComponent } from "./nav/nav.component";
import { HttpClientModule } from "@angular/common/http";
import { LoginComponent } from "./auth/login/login.component";
import { FormsModule } from "@angular/forms";
import { LoginLoadingComponent } from "./auth/login-loading/login-loading.component";
import { FileSelectorComponent } from "./upload/file-selector/file-selector.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FileDownloadComponent } from "./download/file-download/file-download.component";
import { EuroPipe } from "./shared/euro/euro.pipe";
import { RouterModule, Routes } from "@angular/router";
import { UploadPageComponent } from "./upload/upload-page/upload-page.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { ProductsPageComponent } from "./products/products-page/products-page.component";
import { DownloadPageComponent } from "./download/download-page/download-page.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrillantsPageComponent } from "./brillants/brillants-page/brillants-page.component";
import { ValuesPageComponent } from "./values/values-page/values-page.component";
import { ActivityPageComponent } from "./activity/activity-page/activity-page.component";
import { CalculatorMessagesPageComponent } from "./calculator-messages/calculator-messages-page/calculator-messages-page.component";
import { TableHeaderComponent } from "./shared/table-header/table-header.component";
import { SupportComponent } from "./support/modal/support.component";
import { DecimalPipe } from "./shared/decimal/decimal.pipe";
import { ApikeysPageComponent } from "./apikeys/apikeys-page/apikeys-page.component";

const routes: Routes = [
  { path: "upload", component: UploadPageComponent },
  { path: "products", component: ProductsPageComponent },
  { path: "brillants", component: BrillantsPageComponent },
  { path: "values", component: ValuesPageComponent },
  { path: "download", component: DownloadPageComponent },
  { path: "activity", component: ActivityPageComponent },
  { path: "calculator-messages", component: CalculatorMessagesPageComponent },
  { path: "api", component: ApikeysPageComponent },
  { path: "**", redirectTo: "products" },
];

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    LoginComponent,
    LoginLoadingComponent,
    FileSelectorComponent,
    FileDownloadComponent,
    EuroPipe,
    UploadPageComponent,
    SidebarComponent,
    ProductsPageComponent,
    DownloadPageComponent,
    BrillantsPageComponent,
    ValuesPageComponent,
    ActivityPageComponent,
    CalculatorMessagesPageComponent,
    TableHeaderComponent,
    SupportComponent,
    DecimalPipe,
    ApikeysPageComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    FontAwesomeModule,
    RouterModule.forRoot(routes),
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
